import { createApp } from 'vue';
import App from './App.vue';

// FormKit imports
import { plugin as formKitPlugin, defaultConfig } from '@formkit/vue';
import { createMultiStepPlugin } from '@formkit/addons';
import '@formkit/themes/genesis';
import '@formkit/addons/css/multistep';
import AdminView from "@/Views/AdminView.vue";
import RequestAppointmentView from "@/Views/RequestAppointmentView.vue";
import workerService from "@/services/workerService";
import { createRouter, createWebHistory } from "vue-router";
import authService from "@/services/authService";
import CancelRequestView from '@/Views/CancelRequestView.vue';
import LoginView from "@/Views/LoginView.vue";



const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/:worker',
            component: RequestAppointmentView,
            beforeEnter: async (to, from, next) => {
                const worker = to.params.worker;
                try {
                    const data = await workerService.fetchWorkers();
                    const workers = data.workers.map(worker => worker.link);
                    if (workers.includes(worker)) {
                        next();
                    } else {
                        next('/');
                    }
                } catch (error) {
                    console.error('Failed to fetch workers:', error);
                    next('/');
                }
            }
        },
        {
            path: '/',
            component: () => import('@/Views/WorkerSelectorView.vue'),
        },
        {
            path: '/admin',
            component: AdminView,
            beforeEnter: async (to, from, next) => {
                try {
                    const auth = await authService.checkAuth();
                    if (auth.success === true) {
                        next();
                    } else {
                        next('/login');
                    }
                } catch (error) {
                    next('/');
                }
            },
            children: [
                {
                    path: '',
                    redirect: '/admin/general',
                },
                {
                    path: 'workers',
                    component: () => import('@/components/admin/views/WorkersView.vue')
                },
                {
                    path: 'general',
                    component: () => import('@/components/admin/views/GeneralSettingsView.vue')
                },
                {
                    path: 'system',
                    component: () => import('@/components/admin/views/SystemSettingsView.vue')
                },
                {
                    path: 'slack',
                    component: () => import('@/components/admin/views/SlackSettingsView.vue')
                }
            ]
        },
        {
            path: '/cancel',
            component: CancelRequestView,
            props: route => ({
                token: route.query.token,
                workerEmail: route.query.workerEmail
            })
        },
        {
            path: '/login',
            component: LoginView
        }
    ]
});


const app = createApp(App);

app.use(router);

app.use(formKitPlugin, defaultConfig({
    plugins: [createMultiStepPlugin()]
}));

app.mount('#app');
